import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { Whatsapp } from "@/api/api";

const WhatsappSupport = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [whatsappData, setWhatsappData] = useState(null);

  useEffect(() => {
    Whatsapp()
      .then((res) => {
        setWhatsappData(res.data);
      })
      .catch((err) => console.error("Whatsapp API error:", err));
  }, []);

  const toggleOpen = () => setIsOpen(!isOpen);

  if (!whatsappData) return null;

  return (
    <div className="fixed bottom-7 right-4 z-[9999] lg:block hidden">
      {isOpen && (
        <div className="absolute bottom-full right-0 mb-4 w-[320px] bg-white rounded-2xl shadow-2xl overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-300 border border-gray-100 transition-all ease-out">
          <div className="bg-[#0b5c46] p-4 text-white flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="relative w-12 h-12 flex-shrink-0 bg-white rounded-full p-1 overflow-hidden flex items-center justify-center">
                <Image
                  src="/icons/vagon-logox.jpg"
                  alt="Villa Vagonu"
                  width={40}
                  height={40}
                  className="object-contain"
                />
              </div>
              <div className="flex flex-col">
                <h4 className="font-bold text-sm leading-tight">
                  Villa Vagonu
                </h4>
                <p className="text-xs opacity-90 leading-tight">
                  Genellikle 1-2 dakika içinde cevap veririz.
                </p>
              </div>
            </div>
            <button
              onClick={toggleOpen}
              className="text-white hover:opacity-75 p-1 transition-opacity"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="p-5 relative min-h-[160px] bg-[#e5ddd5] bg-[url('/icons/optimizer_whatsapp.jpg')] bg-cover">
            <div className="absolute inset-0 bg-[#e5ddd5] opacity-90 pointer-events-none"></div>

            <div
              className="relative bg-white p-4 rounded-xl rounded-tl-none shadow-md max-w-[95%] flex flex-col gap-2 before:content-[''] before:absolute before:top-0 before:-left-3 before:w-3 before:h-5 before:bg-center before:bg-no-repeat before:bg-[url('/icons/ucgenWhatsapp.png')] before:bg-contain
"
            >
              <div className="flex flex-col">
                <span className="text-[11px] font-bold text-[#075e54]">
                  Villa Vagonu
                </span>
                <p className="text-[13px] text-themeBlack leading-relaxed mt-1">
                  Merhaba 👋 <br />
                  Ben Yasemin, villalarımız ile ilgili bir sorunuz varsa lütfen
                  sohbeti başlatın, Whatsapp üzerinden görüşelim.
                </p>
              </div>
            </div>
          </div>

          <div className="p-4 bg-white border-t border-gray-50">
            <Link
              href={`https://wa.me/${whatsappData.telefon.replace(/\+/g, "")}`}
              target="_blank"
              className="bg-[#25D366] hover:bg-[#128C7E] transition-all text-white py-2.5 px-4 rounded-xl flex items-center justify-center gap-2 font-bold text-[14px] shadow-sm transform active:scale-95"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.472 14.382c-.301-.15-1.78-.878-2.053-.977-.274-.099-.473-.149-.673.15-.2.299-.773.978-.948 1.178-.175.199-.35.223-.651.074-.3-.15-1.268-.468-2.416-1.493-.893-.795-1.496-1.777-1.672-2.076-.175-.299-.019-.461.13-.61.135-.133.301-.35.451-.524.15-.174.2-.299.3-.499.1-.199.05-.374-.025-.523-.075-.15-.673-1.62-.922-2.22-.243-.585-.489-.505-.673-.514-.176-.008-.375-.009-.575-.009-.199 0-.523.075-.797.375-.274.299-1.047 1.023-1.047 2.495 0 1.472 1.072 2.894 1.221 3.094.15.2 2.11 3.221 5.111 4.515.714.307 1.27.491 1.705.63.717.228 1.37.195 1.886.118.574-.085 1.78-.727 2.03-1.428.25-.701.25-1.3-.016-1.428-.276-.128-.65-.205-1.047-.355z"
                  fill="white"
                />
                <path
                  d="M12.003 21c-1.745 0-3.418-.465-4.881-1.345L4 20.622l.983-2.998A8.952 8.952 0 013.91 12.01a9 9 0 1118 0c0 4.963-4.04 9-8.907 9z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Yazışmaya Başla
            </Link>
          </div>
        </div>
      )}
      <button
        onClick={toggleOpen}
        className="bg-[#218d3f] text-white px-5 py-3 rounded-full flex items-center gap-3 shadow-[0_4px_12px_rgba(33,141,63,0.4)] [box-shadow:inset_0_-4px_0_rgba(0,0,0,0.1)] hover:shadow-xl transition-all relative border border-[#36ab53] active:scale-95 group"
      >
        <div className="absolute inset-0 rounded-full border-2 border-[#44bd32] animate-whatsapp-pulse pointer-events-none"></div>
        <div className="absolute inset-0 rounded-full border-2 border-[#44bd32] animate-whatsapp-pulse [animation-delay:0.4s] pointer-events-none"></div>

        <div className="flex items-center justify-center relative z-10">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.472 14.382c-.301-.15-1.78-.878-2.053-.977-.274-.099-.473-.149-.673.15-.2.299-.773.978-.948 1.178-.175.199-.35.223-.651.074-.3-.15-1.268-.468-2.416-1.493-.893-.795-1.496-1.777-1.672-2.076-.175-.299-.019-.461.13-.61.135-.133.301-.35.451-.524.15-.174.2-.299.3-.499.1-.199.05-.374-.025-.523-.075-.15-.673-1.62-.922-2.22-.243-.585-.489-.505-.673-.514-.176-.008-.375-.009-.575-.009-.199 0-.523.075-.797.375-.274.299-1.047 1.023-1.047 2.495 0 1.472 1.072 2.894 1.221 3.094.15.2 2.11 3.221 5.111 4.515.714.307 1.27.491 1.705.63.717.228 1.37.195 1.886.118.574-.085 1.78-.727 2.03-1.428.25-.701.25-1.3-.016-1.428-.276-.128-.65-.205-1.047-.355z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.003 2c-5.522 0-10 4.477-10 10 0 1.767.46 3.428 1.262 4.864L2.003 22l5.326-1.263C8.68 21.43 10.28 22 12.003 22c5.523 0 10-4.477 10-10 0-5.523-4.477-10-10-10zM12.003 20c-1.737 0-3.35-.558-4.66-1.503l-.334-.241-3.149.747.76-2.998-.262-.418A7.95 7.95 0 014.003 12c0-4.418 3.582-8 8-8s8 3.582 8 8c0 4.419-3.582 8.001-8 8.001z"
              fill="white"
            />
          </svg>
        </div>
        <span className="font-bold text-[15px] tracking-wide relative z-10">
          Whatsapp (ONLINE)
        </span>
        <span className="absolute top-0.5 right-0.5 w-3.5 h-3.5 bg-red-600 rounded-full border-2 border-white animate-pulse z-20"></span>
      </button>
    </div>
  );
};

export default WhatsappSupport;
